

export default {
components: {},
methods: {
jump: function (e) {
this.$router.push(e);
},
chapterView:function(id)
{

},
hide:function()
{
var cNode1= document.getElementsByClassName("lv1");
var cNode2= document.getElementsByClassName("lv2");
for(var i=0;i<cNode1.length;i++){
cNode1[i].style.display = "none";
}
for(var i=0;i<cNode2.length;i++){
cNode2[i].style.display = "block";
}
},
},
data() {
return {
CatalogInfo:[],
}
},
created() {
this.$tyh.GetCourse(this.$route.params.IDCode)
.then((data) => {
this.CatalogInfo =data.data.Data.chapter;
});
},
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Catalog.vue